import * as React from 'react'
import { ReactElement } from 'react'
import EnumPicker, { EnumPickerLabel, EnumPickerProps } from './EnumPicker'
import { FileStatus } from '../../config/fileConfig'

export type FileStatusPickerProps = Partial<EnumPickerProps<FileStatus>> &
    Required<Pick<EnumPickerProps<FileStatus>, 'selectedOptions' | 'onOptionsSelect'>>

// The order matters for dropdowns.
export const FileStatusLabels: Map<FileStatus, EnumPickerLabel> = new Map<FileStatus, EnumPickerLabel>([
    [FileStatus.Open, { name: 'file.status.open', disabled: false }],
    [FileStatus.Archived, { name: 'file.status.archived', disabled: false }],
])

export default function FileStatusPicker(props: FileStatusPickerProps): ReactElement {
    return (
        <EnumPicker<FileStatus>
            options={[...FileStatusLabels.keys()]}
            labels={FileStatusLabels}
            placeholderKey={'file.status.placeholder'}
            {...props}
        />
    )
}
